module.exports = __webpack_public_path__ + "static/media/Google_Maps_pin.90cb592a.svg";